import { useTranslation } from 'react-i18next';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import BenefitsSection from './components/BenefitsSection';
import AboutFAQSection from './components/AboutFAQSection';
import CategoriesSection from './components/CategoriesSection';
import ArticlesSection from './components/ArticlesSection';
import TrustSection from './components/TrustSection';
import CTASection from './components/CTASection';
import SafetySection from './components/SafetySection';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://cssbuy.pro';

export default function Home() {
  const { t } = useTranslation('home');

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'CSSBuy Spreadsheet',
    url: siteUrl,
    description: 'Melhor CSSBuy Spreadsheet em português com links atualizados, guias completos e dicas de segurança para compras internacionais.',
    inLanguage: 'pt-PT',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteUrl}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      { '@type': 'Question', name: t('faq_q1'), acceptedAnswer: { '@type': 'Answer', text: t('faq_a1') } },
      { '@type': 'Question', name: t('faq_q2'), acceptedAnswer: { '@type': 'Answer', text: t('faq_a2') } },
      { '@type': 'Question', name: t('faq_q3'), acceptedAnswer: { '@type': 'Answer', text: t('faq_a3') } },
      { '@type': 'Question', name: t('faq_q4'), acceptedAnswer: { '@type': 'Answer', text: t('faq_a4') } },
      { '@type': 'Question', name: t('faq_q5'), acceptedAnswer: { '@type': 'Answer', text: t('faq_a5') } },
      { '@type': 'Question', name: t('faq_q6'), acceptedAnswer: { '@type': 'Answer', text: t('faq_a6') } },
      { '@type': 'Question', name: t('faq_q7'), acceptedAnswer: { '@type': 'Answer', text: t('faq_a7') } },
      { '@type': 'Question', name: t('faq_q8'), acceptedAnswer: { '@type': 'Answer', text: t('faq_a8') } },
    ],
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Início', item: siteUrl },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <article>
            <HeroSection />

            <BenefitsSection />

            <AboutFAQSection />

            <CategoriesSection />

            <ArticlesSection />

            <TrustSection />

            <CTASection />

            <SafetySection />
          </article>
        </main>

        <Footer />
      </div>
    </>
  );
}